

const initialState = {timeParution: 1,};

function tendanceReducer(state : any = initialState,action : any){
    let nextState;

    switch (action.type){
        case 'CHANGE_TIME_PARUTION':
            nextState = _changeTimeParution(state,action);
            return nextState || state;
        default :
            return state;
    }
}

function _changeTimeParution(state :any,action:any){
    const timeParution=action.value;

    return {
        ...state,
        timeParution : timeParution
    }
}

export default tendanceReducer;
